import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import { EditButton, DeletButton } from "../../common/Button";
import { Button } from "react-bootstrap";
import { IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";

const PERM = IDS.Qualification || IDS.Country;

const Tables = () => {
  const { getData, editStatusData, deleteData, ErrorNotify, Per_Page_Dropdown, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [perPage, setperPage] = useState(5);
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [option, setOption] = useState();
  const [showAdd, setShowAdd] = useState(false);
  const [editId, setEditId] = useState(0);
  const [del, setDel] = useState(null); // { id, name }

  useEffect(() => {
    (async () => {
      const response = await getData(
        `/admin/career/qualification?page=${onPageChange}&per_page=${perPage}&term=${encodeURIComponent(search)}`
      );
      setData(response);
      setOption(await Per_Page_Dropdown(response?.data?.total));
    })();
    // eslint-disable-next-line
  }, [perPage, onPageChange, refresh, showAdd, editId]);

  const applySearch = () => {
    setonPageChange(1);
    setRefresh((r) => !r);
  };

  const changeStatus = async (id) => {
    await editStatusData(`/admin/career/qualification/${id}`);
    setRefresh((r) => !r);
  };

  const confirmDelete = async () => {
    const target = del;
    setDel(null);
    if (!target) return;
    await deleteData(`/admin/career/qualification/${target.id}`);
    ErrorNotify(target.name);
    setRefresh((r) => !r);
  };

  const rows = data?.data?.data || [];
  const total = data?.data?.total || 0;
  const currentPage = data?.data?.current_page || 1;
  const size = Number(perPage) || 5;
  const from = total ? (currentPage - 1) * size + 1 : 0;
  const to = Math.min(currentPage * size, total);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Qualification"} link={"/admin/career/qualification"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  <div className="row">
                    <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="add me-3">
                        {isAllow?.includes(PERM.Add) && (
                          <Link type="button" className="btn btn-add pe-3">
                            <div onClick={() => setShowAdd(true)}>
                              <img src={plus} className="plus me-2 ms-0" alt="" />
                              Add Qualification
                            </div>
                          </Link>
                        )}
                      </div>
                    </div>

                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex align-items-center mb-1">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((o) => (
                                <option key={o} value={o}>
                                  {o}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${from} to ${to} of ${total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row align-items-start">
                          <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                            <div className="num">
                              <label className="form-label"></label>
                              <input
                                type="text"
                                className="form-control"
                                value={search}
                                placeholder="Search Qualification"
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && applySearch()}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <div className="Search">
                              <label className="form-label"></label>
                              <Button type="button" onClick={applySearch} className="btn btn-search">
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <div className="Search-1">
                              <label className="form-label"></label>
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  applySearch();
                                }}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            <th className="sr">Sr. No.</th>
                            <th className="tax-name">Qualification Name</th>
                            <th className="tax-name">Status</th>
                            <th className="active">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((d, index) => (
                            <tr key={d?.id ?? index}>
                              <td>{(onPageChange - 1) * size + index + 1}.</td>
                              <td className="width_dertails_name_div">{d?.name}</td>
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    checked={!!d.status}
                                    disabled={!isAllow?.includes(PERM.Edit)}
                                    onChange={() => changeStatus(d.id)}
                                    id={`flexSwitchCheckDefault${d?.id}`}
                                  />
                                  <label className="form-check-label" htmlFor={`flexSwitchCheckDefault${d?.id}`}>
                                    {d.status ? "Active" : "Inactive"}
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex">
                                  {isAllow?.includes(PERM.Edit) && (
                                    <EditButton handleShow1={(id) => setEditId(id)} id={d?.id} />
                                  )}
                                  {isAllow?.includes(PERM.Delete) && (
                                    <DeletButton
                                      showDeleteRecord={(id, name) => setDel({ id, name })}
                                      id={d?.id}
                                      name={d?.name}
                                    />
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      {rows.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={data?.data?.total_pages}
                          handlePageChange={setonPageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {showAdd ? <AddOffCanvance handleClose={() => setShowAdd(false)} setShow={setShowAdd} show={showAdd} /> : ""}
      {editId ? <EditOffCanvance handleClose={() => setEditId(0)} setShow={setEditId} show={editId} /> : ""}

      <ModalDelete show={!!del} handleDeleteRecord={confirmDelete} handleDeleteCancel={() => setDel(null)} />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;